import request from "@/utils/request";
export function getPage(condition, pagination) {
  return request({
    url: "/customer/customerApplyChange/page",
    method: "post",
    data: { condition: condition, pagination: pagination },
  });
}
export function getSalesOrganization(condition, pagination) {
  return request({
    url: "/base/salesOrganization/pagePopup",
    method: "post",
    data: { condition: condition, pagination: pagination },
  });
}


export function saveOrUpdate(data) {
  return request({
    url: "/customer/customerApplyChange/saveOrUpdate",
    method: "post",
    data,
  });
}

export function get(id) {
  return request({
    url: "/customer/customerApplyChange/get",
    method: "get",
    params: { id },
  });
}

export function deleteById(id) {
  return request({
    url: "/customer/customerApplyChange/deleteById",
    method: "post",
    data: { id: id },
  });
}

export function exportExcel(condition, pagination) {
  return request({
    url: "/customer/customerApplyChange/exportExcel",
    method: "post",
    data: { condition: condition, pagination: pagination },
    responseType: "blob",
  });
}
// 获取省市
export function areaList(data) {
  console.log(data)
  return request({
    url: "/customer/customerApply/areaList",
    method: "post",
    data,
  });
}

export function submit(id) {
  return request({
    url: "/customer/customerApplyChange/submit",
    method: "post",
    data: { id: id },
  });
}